import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import api from '../../services/api';

const DataList = ({ endpoint, columns, renderActions, refreshTrigger, data: externalData, onRowClick }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (externalData !== undefined) {
      setData(Array.isArray(externalData) ? externalData : []);
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        const response = await api.get(endpoint);
        const data = response.data.results || response.data;
        setData(Array.isArray(data) ? data : []);
      } catch (err) {
        setError('Ошибка загрузки данных');
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [endpoint, refreshTrigger, externalData]);

  if (loading) return <Typography>Загрузка...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col.key}>{col.label}</TableCell>
            ))}
            {renderActions && <TableCell>Действия</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index} onClick={() => onRowClick && onRowClick(item)} sx={{ cursor: onRowClick ? 'pointer' : 'default' }}>
              {columns.map((col) => (
                <TableCell key={col.key} style={{ whiteSpace: 'pre-line' }}>
                  {col.render ? col.render(item[col.key], item) : item[col.key]}
                </TableCell>
              ))}
              {renderActions && <TableCell>{renderActions(item)}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataList;